/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import StyledPrivateLayout from "./StyledPrivateLayout";
import {
  AppBar,
  Box,
  Button,
  Divider,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Modal,
  Toolbar,
  Typography,
  useMediaQuery,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import wanderobeLogo from "../../assets/images/wanderobe-logo-1.svg";
import { ROUTE_PATH } from "../../constants/route";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import MonetizationOnOutlinedIcon from "@mui/icons-material/MonetizationOnOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
import ControlPointOutlinedIcon from "@mui/icons-material/ControlPointOutlined";
import ViewInArOutlinedIcon from "@mui/icons-material/ViewInArOutlined";
import { theme } from "../../theme";
import HeadsetMicOutlinedIcon from "@mui/icons-material/HeadsetMicOutlined";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import { BorderButton } from "../../components/CommonComponents/Button";
import { fetchLogout } from "../../store/reducers/authentication/apiThunk";
import { useDispatch, useSelector } from "react-redux";
import Analytics from "../../components/Analytics";
import shopifyLogo from "../../assets/images/shopifyLogo.svg";
import { fetchShopifyAccountCheck } from "../../store/reducers/createProfile/apithunk";
import { actions } from "../../store/reducers/createProfile";

const {
  PRIVATE_DASHBOARD,
  CUSTOMER_SUPPORT,
  FAVOURITES,
  INVOICES,
  ORDER_MANAGEMENT,
  PAYMENTS,
  INVENTORY_SETUP,
  SHOPIFY_SETUP
} = ROUTE_PATH;

const MainListItems = [
  { title: "Dashboard", icon: "dashboard", url: PRIVATE_DASHBOARD },
  {
    title: "Order Management",
    icon: "Order_Management",
    url: ORDER_MANAGEMENT,
  },
  { title: "Payments", icon: "Payments", url: PAYMENTS },
  { title: "Invoices", icon: "Invoices", url: INVOICES },
  { title: "Favorites", icon: "Favourites", url: FAVOURITES },
];

const ProductsListItems = [
  // { title: "Add Products", icon: "products" },
  { title: "Inventory Management", icon: "Inventory_Management", url: INVENTORY_SETUP },
  { title: "Shopify Inventory", icon: "Shopify_Management", url: SHOPIFY_SETUP },
];


const SupportListItems = [
  { title: "Customer Support", icon: "Support", url: CUSTOMER_SUPPORT },
];

const PrivateLayout = ({ privateRoute = false, children, title }) => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const isDesktop = useMediaQuery("(min-width:900px)");
  const location = useLocation();
  const dispatch = useDispatch();
  const { pathname } = location;
  const [anchorEl, setAnchorEl] = useState(null);
  const [openLogoutModal, setOpenLogoutModal] = useState(false);
  const authentication = useSelector((state) => state.authentication);
  const createProfile = useSelector((state) => state.createProfile);
  const navigate = useNavigate();
  const profile = useSelector((state) => state?.createProfile?.userProfile);
  const shopifyAccountCheck = createProfile?.shopifyAccountCheck;

  useEffect(() => {
    const token =
      authentication?.auth?.data?.auth_token ||
      authentication?.auth?.data?.data?.auth_token ||
      authentication?.userData?.data?.auth_token ||
      null;
    if (token) {
      if ([ROUTE_PATH.LOGIN, ROUTE_PATH.SIGNUP].includes(location?.pathname)) {
        navigate(ROUTE_PATH.PRIVATE_DASHBOARD);
      } else if ([ROUTE_PATH.DASHBOARD].includes(location?.pathname)) {
        navigate(ROUTE_PATH.PRIVATE_DASHBOARD);
      }
    } else if (privateRoute === true) {
      if (![ROUTE_PATH.LOGIN, ROUTE_PATH.SIGNUP].includes(location?.pathname)) {
        navigate(ROUTE_PATH.DASHBOARD);
      }
    }

  }, [authentication, privateRoute, location?.pathname]);

  // Check and fetch Shopify account data if user is logged in but no data exists
  useEffect(() => {
    const token =
      authentication?.auth?.data?.auth_token ||
      authentication?.auth?.data?.data?.auth_token ||
      authentication?.userData?.data?.auth_token ||
      null;
      if (token && (!shopifyAccountCheck?.message?.length > 0)) {
      dispatch(fetchShopifyAccountCheck());
    } else {
      if(!token){
        dispatch(actions.clearShopifyAccountCheck());
      } else {
        console.log("already has data")
      }
    }
  }, [authentication, dispatch]);


  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const toggleDrawer = (open) => () => {
    setDrawerOpen(open);
  };

  const getColor = (path) => {
    if (pathname === path) {
      return theme.palette.secondary.main;
    } else {
      return theme.palette.customColor.secondSecondary;
    }
  };

  const handleGetIcon = (type) => {
    switch (type) {
      case "dashboard":
        return (
          <HomeOutlinedIcon sx={{ color: `${getColor(PRIVATE_DASHBOARD)}` }} />
        );
      case "Order_Management":
        return <ShoppingCartOutlinedIcon sx={{ color: `${getColor(ORDER_MANAGEMENT)}}` }} />
      case "Payments":
        return (
          <MonetizationOnOutlinedIcon sx={{ color: `${getColor(PAYMENTS)}` }} />
        );
      case "Invoices":
        return <DescriptionOutlinedIcon sx={{ color: `${getColor(INVOICES)}` }} />
      case "Favourites":
        return <FavoriteBorderOutlinedIcon sx={{ color: `${getColor(FAVOURITES)}` }} />
      case "products":
        return <ControlPointOutlinedIcon sx={{ color: `${getColor(PRIVATE_DASHBOARD)}` }} />
      case "Inventory_Management":
        return <ViewInArOutlinedIcon sx={{ color: `${getColor(INVENTORY_SETUP)}` }} />
      case "Support":
        return (
          <HeadsetMicOutlinedIcon
            sx={{ color: `${getColor(CUSTOMER_SUPPORT)}` }}
          />
        );
      case "Shopify_Management":
        return <img src={shopifyLogo} alt="shopify" style={{ width: "20px", height: "20px" }} />
      default:
        break;
    }
  };

  return (
    <StyledPrivateLayout>
      <Analytics />
      <Box className='private-layout'>
        <AppBar position='fixed' className='dashboard-layout'>
          <Toolbar className='toolbar'>
            {isDesktop ? (
              <Box className='mune-wrap-desktop'>
                <Typography className='dashboard-title'>{title}</Typography>
                <Box>
                  <Box className='profileButton' onClick={handleMenuOpen}>
                    <Box className='profile-image'>
                      <img
                        src={profile?.brand_image}
                        alt='aa'
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          borderRadius: "50%",
                        }}
                      />
                    </Box>
                    <KeyboardArrowDownRoundedIcon className='iconBackground' />
                  </Box>
                  <Menu
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={handleMenuClose}
                    PaperProps={{
                      className: "dropdownMenu",
                    }}
                  >
                    <MenuItem
                      className='dropDownRow1'
                      onClick={handleMenuClose}
                    >
                      <Box className='profile-image'>
                        <img
                          src={profile?.brand_image}
                          alt='aa'
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            borderRadius: "50%",
                          }}
                        />
                      </Box>
                      <Box>
                        <Typography
                          className='dorpDownUserName'
                          sx={{
                            display: '-webkit-box',
                            overflow: 'hidden',
                            WebkitBoxOrient: 'vertical',
                            WebkitLineClamp: 2,
                            textOverflow: 'ellipsis',
                            whiteSpace: 'normal',
                            maxWidth: '150px',
                          }}
                        >
                         {profile?.seller_name || "username"}
                        </Typography>
                        <Typography className='dorpDownViewProfile' onClick={() => navigate(ROUTE_PATH.EDIT_PROFILE)}>
                          View Profile
                        </Typography>
                      </Box>
                    </MenuItem>
                    <MenuItem 
                      className='dropDownRow2'
                      sx={{
                        '&:hover': {
                          backgroundColor: 'transparent', // Remove hover background
                        },
                        padding: 0, // Remove padding to prevent hover area outside button
                      }}
                    >
                      <Button
                        onClick={() => {
                          setOpenLogoutModal(true);
                          setAnchorEl(null);
                        }}
                        variant="outlined"
                        color="primary"
                        sx={{
                          margin: "10px auto 0px",
                          width: "80%",
                          backgroundColor: "white",
                          color: "black",
                          borderRadius: "0px",
                          padding: "7px 20px",
                          fontFamily: "Lexend",
                          textTransform: "none",
                          fontWeight: "400",
                          boxShadow: 'none',
                        }}
                      >
                        Log out
                      </Button>
                    </MenuItem>
                  </Menu>
                </Box>
              </Box>
            ) : (
              <Box className='mune-wrap-desktop'>
                <Box className='mune-wrap'>
                  <IconButton
                    edge='start'
                    color='inherit'
                    onClick={toggleDrawer(true)}
                    aria-label='menu'
                    sx={{ color: `${theme.palette.primary.main}` }}
                  >
                    <MenuIcon />
                  </IconButton>
                  <Typography className='dashboard-title'>{title}</Typography>
                </Box>
                <Box>
                  <Box className='profileButton' onClick={handleMenuOpen}>
                    <Box className='profile-image'>
                      <img
                        src={profile?.brand_image}
                        alt='aa'
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          borderRadius: "50%",
                        }}
                      />
                    </Box>
                    <KeyboardArrowDownRoundedIcon className='iconBackground' />
                  </Box>
                  <Menu
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={handleMenuClose}
                    PaperProps={{
                      className: "dropdownMenu",
                    }}
                  >
                    <MenuItem
                      className='dropDownRow1'
                      onClick={handleMenuClose}
                    >
                      <Box className='profile-image'>
                        <img
                          src={profile?.brand_image}
                          alt='aa'
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            borderRadius: "50%",
                          }}
                        />
                      </Box>
                      <Box>
                        <Typography
                          className='dorpDownUserName'
                          sx={{
                            display: '-webkit-box',
                            overflow: 'hidden',
                            WebkitBoxOrient: 'vertical',
                            WebkitLineClamp: 2,
                            textOverflow: 'ellipsis',
                            whiteSpace: 'normal',
                            maxWidth: '150px',
                          }}
                        >
                          { profile?.seller_name || "username"}
                        </Typography>
                        <Typography className='dorpDownViewProfile' onClick={() => navigate(ROUTE_PATH.EDIT_PROFILE)}>
                          View Profile
                        </Typography>
                      </Box>
                    </MenuItem>
                    <MenuItem className='dropDownRow2'>
                    <Button
                        onClick={() => {
                          setOpenLogoutModal(true);
                          setAnchorEl(null);
                        }}
                        variant="outlined"
                        color="primary"
                        sx={{
                          margin: "10px auto 0px",
                          width: "80%",
                          backgroundColor: "white",
                          color: "black",
                          borderRadius: "0px",
                          padding: "7px 20px",
                          fontFamily: "Lexend",
                          textTransform: "none",
                          fontWeight: "400",
                          '&:hover': {
                            backgroundColor: "black",
                          },
                          boxShadow: 'none',
                        }}
                      >
                        Log out
                      </Button>
                    </MenuItem>
                  </Menu>
                </Box>
              </Box>
            )}
          </Toolbar>
        </AppBar>

        <Drawer
          variant={isDesktop ? "permanent" : "temporary"}
          anchor='left'
          open={isDesktop || drawerOpen}
          onClose={toggleDrawer(false)}
          sx={{
            "& .MuiDrawer-paper": {
              width: 260,
            },
          }}
        >
          <Box
            sx={{ width: 260 }}
            role='presentation'
            onClick={!isDesktop ? toggleDrawer(false) : undefined}
          >
            <Toolbar>
              <Link to={ROUTE_PATH.PRIVATE_DASHBOARD} className='logo'>
                <img src={wanderobeLogo} alt='logo' width='151px' />
              </Link>
            </Toolbar>
            <Box className='profile'>
              <Box className='profile-details'>
                <Box className='profile-image'>
                  <img
                    src={profile?.brand_image}
                    alt='aa'
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      borderRadius: "50%",
                    }}
                  />
                </Box>
                <Box className='profile-name'>
                  <Typography className='profile-store-text'>
                    Store Name
                  </Typography>
                  <Typography className='profile-name-text'>
                    {(profile?.seller_name || "username")?.length > 20
                      ? `${(profile?.seller_name || "username")?.slice(0, 20)}...`
                      : profile?.seller_name || "username"}
                  </Typography>
                </Box>
              </Box>
            </Box>
            <Divider />
            <List>
              <Typography className='drawer-headers'>MAIN MENU</Typography>
              {MainListItems.map(({ title, icon, url }, index) => {
                return (
                  <Box key={index} className='drawer-item'>
                    <Link className='drawer-links' to={url}>
                      <ListItem className='drawer-main-item'>
                        <ListItemButton
                          className={`drawer-main-btn ${url === pathname ||
                            url === pathname.slice(0, pathname.lastIndexOf("/"))
                            ? "active"
                            : ""
                            }`}
                        >
                          <ListItemIcon className='drawer-main-icon'>
                            {handleGetIcon(icon)}
                          </ListItemIcon>
                          <ListItemText
                            primaryTypographyProps={{
                              className: `drawer-main-text ${url === pathname ||
                                url ===
                                pathname.slice(0, pathname.lastIndexOf("/"))
                                ? "active-text"
                                : ""
                                }`,
                            }}
                            primary={title}
                          />
                        </ListItemButton>
                      </ListItem>
                    </Link>
                  </Box>
                );
              })}
            </List>
            <List>
              <Typography className='drawer-headers'>PRODUCTS</Typography>
              { ProductsListItems?.length > 0 && ProductsListItems?.map(({ title, icon, url }, index) => {
                // Check if current path matches the menu item URL or is a sub-route
                const isActive = url === pathname || 
                  pathname.startsWith(url + "/") ||
                  url === pathname?.slice(0, pathname?.lastIndexOf("/"));
                
                return (
                  <Box key={index} className='drawer-item'>
                    <Link className='drawer-links' to={url}>
                      <ListItem className='drawer-main-item'>
                        <ListItemButton
                          className={`drawer-main-btn ${isActive ? "active" : ""}`}
                        >
                          <ListItemIcon className='drawer-main-icon'>
                            {handleGetIcon(icon)}
                          </ListItemIcon>
                          <ListItemText
                            primary={title}
                            primaryTypographyProps={{
                              className: "drawer-main-text",
                            }}
                          />
                        </ListItemButton>
                      </ListItem>
                    </Link>
                  </Box>
                );
              })}
            </List>
            <List>
              <Typography className='drawer-headers'>SUPPORT</Typography>
              {SupportListItems.map(({ title, icon, url }, index) => {
                return (
                  <Box key={index} className='drawer-item'>
                    <Link className='drawer-links' to={url}>
                      <ListItem className='drawer-main-item'>
                        <ListItemButton
                          className={`drawer-main-btn ${url === pathname ||
                            url === pathname.slice(0, pathname.lastIndexOf("/"))
                            ? "active"
                            : ""
                            }`}
                        >
                          <ListItemIcon className='drawer-main-icon'>
                            {handleGetIcon(icon)}
                          </ListItemIcon>
                          <ListItemText
                            primaryTypographyProps={{
                              className: "drawer-main-text",
                            }}
                            primary={title}
                          />
                        </ListItemButton>
                      </ListItem>
                    </Link>
                  </Box>
                );
              })}
            </List>
          </Box>
        </Drawer>
        <Box component='main' className='dashboard-layout-body'>
          {(() => {
            const token =
              authentication?.auth?.data?.auth_token ||
              authentication?.auth?.data?.data?.auth_token ||
              authentication?.userData?.data?.auth_token ||
              null;
            
            // Only render children if we have a token or if this is not a private route
            if (token || !privateRoute) {
              return children;
            }
            // Return nothing if no token and privateRoute=true
            return null;
          })()}
        </Box>
      </Box>
      <Modal
        open={openLogoutModal}
        onClose={() => setOpenLogoutModal(false)}
        className='logout-modal'
      >
        <Box className='logout-modal-content'>
          <Typography className='logout-modal-title'>Log out?</Typography>
          <Typography className='logout-modal-text'>
            Are you sure you want to log out?
          </Typography>
          <Box className='logout-modal-btns'>
            <BorderButton
              className='logout-modal-cancel-btn'
              onClick={() => setOpenLogoutModal(false)}
            >
              Cancel
            </BorderButton>
            <Button
              variant='contained'
              color='primary'
              className='logout-modal-yes-btn'
              onClick={() => dispatch(fetchLogout())}
            >
              Confirm
            </Button>
          </Box>
        </Box>
      </Modal>
    </StyledPrivateLayout>
  );
};

export default PrivateLayout;
